import { query_client } from '$tablet-app/src/app/query_client';
import { CheckListItem, parseChecklistItems } from '@akin-home/checklists';
import {
  getMinimalTaskList,
  listAllChecklistsQuery,
  updateTaskListMutation,
} from '@akin-home/checklists/frontend';
import { removeByID } from '@akin-home/records';
import Fuse from 'fuse.js';
import { AddChatItemFunction } from '../../types';
import { DeleteChecklistItemCommand } from '../types';

const deleteListItemCommand = async (
  command: DeleteChecklistItemCommand,
  AddItem: AddChatItemFunction
) => {
  const result = DeleteChecklistItemCommand.safeParse(command);

  if (!result.success) {
    return;
  }

  const {
    data: { checklist_title, not_found_message, item_text },
  } = result.data;

  let checklist_id = result.data.data.checklist_id;
  let checklist_items: CheckListItem[] = [];

  if (checklist_id?.length) {
    const checklist = (await getMinimalTaskList(checklist_id)).data.getTaskList;

    if (checklist) {
      checklist_items = parseChecklistItems(checklist.checklist);
    }
  } else if (checklist_title) {
    const items = await listAllChecklistsQuery({
      query: { title: checklist_title },
    });

    console.log('Found checklists: ', items);

    if (items.length > 0) {
      const { id, checklist = [] } = items[0];

      checklist_id = id;
      checklist_items = checklist;
    }
  }

  if (checklist_id && checklist_items.length > 0) {
    const item = new Fuse(checklist_items, search_options)
      .search(item_text)
      .map(({ item }) => item)[0];

    console.log('Found item: ', item);

    // A matching checklist item was found
    if (item) {
      await updateTaskListMutation({
        input: {
          id: checklist_id,
          checklist: JSON.stringify(removeByID(checklist_items, item.id)),
        },
      });

      query_client.invalidateQueries('checklists');
    }
  }
};

const search_options = {
  isCaseSensitive: false,
  threshold: 0.3,
  keys: ['title'],
};

export default deleteListItemCommand;
